import React from 'react';
import * as Yup from 'yup';
import { Box, Typography, InputAdornment, styled } from '@mui/material';

// Shared building blocks for the Admin / User / Issuer profile forms so the
// three pages stay visually and behaviourally consistent.

// Required + linkedin.com URL validation, reused by every profile form.
export const linkedInUrlValidation = Yup.string()
  .required('LinkedIn Profile URL is required')
  .matches(
    /^https?:\/\/(www\.)?linkedin\.com\/.+/i,
    'Enter a valid LinkedIn URL (e.g. https://www.linkedin.com/in/your-name)'
  );

// Red required-field asterisk used inside field labels.
export const RedAsterisk = styled('span')({
  color: 'red',
});

// Renders a field label with the required asterisk appended.
export const RequiredLabel = ({ children }) => (
  <>
    {children} <RedAsterisk>*</RedAsterisk>
  </>
);

// Tinted gradient band that sits behind the profile title + avatar and spans
// the full width of the (padding-less) Card.
export const ProfileHeaderBand = styled(Box)(({ theme }) => ({
  background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.primary.dark} 100%)`,
  padding: theme.spacing(3, 2, 4),
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
}));

// Small uppercase group heading (PERSONAL / COMPANY / SOCIAL ...).
export const SectionLabel = ({ children, sx }) => (
  <Typography
    variant="overline"
    sx={{
      display: 'block',
      color: 'text.secondary',
      fontWeight: 700,
      letterSpacing: '0.08em',
      ...sx,
    }}
  >
    {children}
  </Typography>
);

// Returns an `InputProps` object that renders a leading icon inside a TextField.
export const startIcon = (icon) => ({
  startAdornment: (
    <InputAdornment position="start" sx={{ color: 'action.active' }}>
      {icon}
    </InputAdornment>
  ),
});
